import WorkforceGapGenderEthnicityCard from './WorkforceGapGenderEthnicityCard';
export default WorkforceGapGenderEthnicityCard;
